const initialState = {
  loginLoader: false,
  loginType: null,
  loginPayload: {},
  RegisterPayload: {},
  loginResponse: {},
  loginPayloadTwoFactor: null,
  twoFactorTimerActive: false,
};

const LoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case "NATIVE_LOGIN":
      // Clear timer state on successful login with token
      if (
        action.payload &&
        action.payload.data &&
        action.payload.data.autho_token
      ) {
        return {
          ...state,
          loginPayload: action.payload,
          loginType: "NATIVE_LOGIN",
          loginPayloadTwoFactor: null,
          twoFactorTimerActive: false,
        };
      }
      return {
        ...state,
        loginPayload: action.payload,
        loginType: "NATIVE_LOGIN",
      };
    case "SET_LOGIN_RESPONSE":
      return { ...state, loginResponse: action.payload };
    case "SHOW_LOGIN_LOADER":
      return { ...state, loginLoader: true };
    case "HIDE_LOGIN_LOADER":
      return { ...state, loginLoader: false };
    case "SET_LOGIN_RESPONSE_FOR_TWOFACTOR":
      return {
        ...state,
        loginPayloadTwoFactor: action.payload,
        twoFactorTimerActive: !!action.payload,
      };
    case "START_TWO_FACTOR_TIMER":
      return {
        ...state,
        twoFactorTimerActive: true,
      };
    case "CLEAR_TWO_FACTOR_TIMER":
    case "TWO_FACTOR_TIMEOUT":
      return {
        ...state,
        loginPayloadTwoFactor: null,
        twoFactorTimerActive: false,
      };
    case "LOGOUT": {
      // console.log("LOGIN LOGOUT")
      return initialState;
    }
    default:
      return state;
  }
};

export default LoginReducer;
